import { useTranslation } from "react-i18next"
import { useOutletContext } from "react-router"
import { PatientInformationProps } from "@/modules/patients/detail/sick-leave-certificate/de/de-sick-leave-certificate-drawer.tsx"
import useCallContextStore from "@/stores/useCallContextStore"

const useExistingPhoneNumberList = (isCorrespondence: boolean) => {
  const [t] = useTranslation()
  const contextData = useOutletContext<PatientInformationProps>()

  const callerPhoneNumber = useCallContextStore((state) => state.callerPhoneNumber)
  const existingPhoneNumberLists = []
  const callerPhoneNumberObject = {
    phoneNumber: callerPhoneNumber,
    label: t("callDummy.callerPhoneNumber"),
  }
  const correspondenceNumberObject = {
    phoneNumber: contextData?.patient?.phoneNumber ?? "",
    label: t("patient.information.correspondenceContact"),
  }

  if (callerPhoneNumber && callerPhoneNumber.length > 4) {
    existingPhoneNumberLists.push(callerPhoneNumberObject)
  }

  if (isCorrespondence && contextData?.patient?.phoneNumber && contextData?.patient?.phoneNumber.length > 4) {
    existingPhoneNumberLists.push(correspondenceNumberObject)
  }

  return { existingPhoneNumberLists }
}

export { useExistingPhoneNumberList }
